import { z } from 'zod'

export const OptionItemsUnavailableSchema = z.object({
  errorResolutionType: z.literal('OPTION_ITEMS_UNAVAILABLE'),
  unavailableOptionItemIds: z.array(z.string()),
})
